import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "@/locales/en.json";
import sq from "@/locales/sq.json";

// Languages catalogue — single source of truth.
// Add a new entry here + drop a json file in /locales to enable a new language.
export const LANGUAGES = [
    { code: "sq", label: "Shqip",   country: "AL", english: "Albanian" },
    { code: "en", label: "English", country: "GB", english: "English"  },
    // Disabled placeholders (will light up when JSON is added)
    // { code: "it", label: "Italiano",  country: "IT", english: "Italian" },
    // { code: "el", label: "Ελληνικά",  country: "GR", english: "Greek"   },
    // { code: "de", label: "Deutsch",   country: "DE", english: "German"  },
];

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            sq: { translation: sq },
        },
        fallbackLng: "sq",
        supportedLngs: LANGUAGES.map((l) => l.code),
        interpolation: { escapeValue: false },
        detection: {
            order: ["localStorage", "navigator"],
            lookupLocalStorage: "akm_lang",
            caches: ["localStorage"],
        },
        returnEmptyString: false,
    });

export function setLanguage(code) {
    i18n.changeLanguage(code);
    localStorage.setItem("akm_lang", code);
}

export default i18n;
